
// Mutations
export const BINDCHARPROPS = 'BINDCHARPROPS'
export const UNBINDCHARPROPS = 'UNBINDCHARPROPS'

export const RESETCHARPROPS = 'RESETCHARPROPS'

// Actions
export const ADDCHARPROP = 'ADDCHARPROP';
export const DELETECHARPROP = 'DELETECHARPROP';
export const TOGGLECHARPROP = 'TOGGLECHARPROP';


import db from '../../firebase/firebase'
import {
  bindArrayBase,
  removeBoundFromObject,
  updateBoundInObject } from '../helpers/binding';
import { snapshots2objects } from '../helpers/general'

export default {
  state: () => ({
    charprops: {},
  }),

  getters: {
    charSuppliesProperty: ( state ) => ( playerid, charclass, propKey ) => {
      if( !state.charprops[ playerid ] ) return false
      if( !state.charprops[ playerid ][ charclass ] ) return false
      return state.charprops[ playerid ][ charclass ][ propKey ]
    },
  },

  mutations: {
    addBoundCharPropBatch: ( state, arrayOfSnapshots ) => {
      const arrayOfObjects = snapshots2objects( arrayOfSnapshots )
      state.charprops = mergeWith( arrayOfObjects, state.charprops )
    },
    removeBoundCharProp: ( state, { snapshot } ) => removeBoundFromObject( state.charprops, snapshot ),
    updateBoundCharProp: ( state, { snapshot } ) => updateBoundInObject( state.charprops, snapshot ),

    [RESETCHARPROPS] ( state ) {
      state.charprops = {}
    },
  },

  actions: {
    async [BINDCHARPROPS] ( { commit }, guild ) {
      const ref = db.ref( 'guildCharProperties/' + guild['.key'] )
      return bindArrayBase( ref, commit, 'CharProp', true, false, false, null )
    },
    [UNBINDCHARPROPS] ( { rootState } ) {
      let guild = rootState.guilds.selectedGuild
      if( guild ) {
        db.ref( 'guildCharProperties/' + guild['.key'] ).off()
      }
    },
    
    [ADDCHARPROP] ( context, { guild, playerid, charclass, property } ) {
      if( guild && playerid && charclass && property && property.ischarspecific ) {
        db.ref( 'guildCharProperties/' + guild['.key']
                + '/' + playerid + '/' + charclass + '/' + property['.key'] ).set( true )
      }
    },
    [DELETECHARPROP] ( context, { guild, playerid, charclass, property } ) {
      if( guild && playerid && charclass && property && property.ischarspecific ) {
        db.ref( 'guildCharProperties/' + guild['.key'] +
          '/' + playerid + '/' + charclass + '/' + property['.key']).remove()
      }
    },
    [TOGGLECHARPROP] ( { getters, dispatch }, { guild, playerid, charclass, property } ) {
      if( guild && playerid && charclass && property && property.ischarspecific ) {
        if( getters.charSuppliesProperty( playerid, charclass, property['.key'] ) ) {
          dispatch( DELETECHARPROP, { guild, playerid, charclass, property } )
        }
        else {
          dispatch( ADDCHARPROP, { guild, playerid, charclass, property } )
        }
      }
    },

  },
}

function mergeWith( arrayOfObjects, charprops ) {

  let newcharprops = { ...charprops }

  for( let charPropObj of arrayOfObjects ) {

    let playerid = charPropObj['.key']
    newcharprops[ playerid ] = {... charPropObj}

  }

  return newcharprops
}
